import { Option } from '@/modules/entity/utils/option.ts';

export const reasonOptions: Option<string>[] = [
  {
    label: 'No TIN is required',
    value: 'no_required',
  },
  {
    label: 'The Account Holder is otherwise unable to obtain a TIN or equivalent number',
    value: 'unable',
  },
  {
    label:
      'The country where the Account Holder is liable to pay tax does not issue TINs to its residents',
    value: 'liable',
  },
];
